// Shared SmoothBadger artwork. Keep this asset and component consistent across the apps.
export function BrandMark({ size = 40 }: { size?: number }) {
  return <img className="smoothbadger-brand-mark" src="/brand/smoothbadger-mark.png" alt="" aria-hidden="true" width={size} height={size}
    style={{ display: 'inline-block', flexShrink: 0, objectFit: 'contain', borderRadius: '50%', backgroundColor: '#fff', verticalAlign: 'middle' }} />
}
